import { Logo } from "@/components/site/Reveal";

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-heading text-xl font-bold uppercase text-slate-100">{title}</h2>
    <div className="mt-3 space-y-3 text-sm sm:text-base text-slate-300 leading-relaxed">{children}</div>
  </div>
);

export default function Cgv() {
  return (
    <div className="min-h-screen bg-obsidian text-chalk font-sans px-5 py-16">
      <div className="max-w-3xl mx-auto" data-testid="cgv-page">
        <a href="/" className="inline-flex items-center gap-3 mb-10 hover:opacity-80 transition-opacity">
          <Logo size={36} />
          <span className="font-heading font-extrabold uppercase tracking-wide">Yassine Abou</span>
        </a>

        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold uppercase">Conditions Générales de Vente</h1>
        <p className="mt-3 text-xs text-slate-500">Dernière mise à jour : octobre 2026</p>

        <Section title="1. Éditeur du service">
          <p>
            Yassine Abou, entrepreneur individuel — préparation mentale &amp; accompagnement.
            SIRET : 839 229 853 00016.
            Adresse : 17 avenue de Verdun, 91550 Paray-Vieille-Poste.
            Contact : yassineabou.contact@gmail.com.
          </p>
        </Section>

        <Section title="2. Objet">
          <p>
            Les présentes conditions régissent la souscription aux accompagnements proposés sur ce site :
            l'application de préparation mentale « Boussole » et les formules de coaching associées
            (Cercle Collectif, Suivi Individuel).
          </p>
        </Section>

        <Section title="3. Prix et paiement">
          <p>
            Les prix sont indiqués en euros. TVA non applicable, article 293 B du Code général des impôts. Le règlement
            s'effectue par carte bancaire via la plateforme sécurisée Stripe, par prélèvement automatique
            toutes les 4 semaines, à compter de la date de souscription. Aucune donnée bancaire ne transite par
            ce site.
          </p>
          <p>
            Le client peut aussi choisir le <strong className="text-slate-100">paiement annuel en une fois</strong> :
            il règle alors 12 périodes de 4 semaines pour bénéficier de 52 semaines d'accompagnement
            (4 semaines offertes), soit 178,80 € pour Boussole Autonomie, 358,80 € pour Cercle Collectif
            et 1 068 € pour Suivi Individuel.
          </p>
        </Section>

        <Section title="4. Durée et engagement">
          <p>
            Les formules <strong className="text-slate-100">Boussole Autonomie</strong> (14,90 € par période de 4 semaines),
            <strong className="text-slate-100"> Cercle Collectif</strong> (29,90 € par période de 4 semaines) et
            <strong className="text-slate-100"> Suivi Individuel</strong> (89 € par période de 4 semaines) sont souscrites
            avec un <strong className="text-slate-100">engagement de 12 mois</strong> à compter du jour de la souscription (soit 13 prélèvements de 4 semaines), afin de laisser au
            travail le temps de porter ses fruits. En cas de résiliation avant le terme des 12 mois,
            les prélèvements restants de la période d'engagement restent dus.
          </p>
          <p>
            La formule <strong className="text-slate-100">Suivi Individuel</strong> comprend un coaching
            individuel tous les 15 jours, un cours de sport par mois (en visio ou en présentiel), une
            séance de questions-réponses hebdomadaire sur demande, un bilan de progression écrit tous
            les 3 mois, une séance parents par trimestre, un programme physique personnalisé en PDF et,
            sur demande, une séance de préparation avant une échéance importante. Des séances de sport
            supplémentaires peuvent être mobilisées à la demande du client, selon les disponibilités du
            coach ; elles sont facturées en supplément, des packs à tarif dégressif pouvant être proposés.
          </p>
          <p>
            En cas de paiement annuel, l'engagement porte sur 52 semaines à compter du jour de la
            souscription et le paiement couvre l'intégralité de cette durée.
          </p>
        </Section>

        <Section title="5. Résiliation">
          <p>
            À l'issue de la période d'engagement, l'abonnement se poursuit par tacite reconduction
            par périodes de 4 semaines (ou, en cas de paiement annuel, par périodes d'un an, facturées à la date anniversaire) et peut être résilié à tout moment par simple email à
            yassineabou.contact@gmail.com. La résiliation prend effet à la fin de la période de 4 semaines
            en cours ; aucun remboursement au prorata n'est effectué.
          </p>
        </Section>

        <Section title="6. Droit de rétractation">
          <p>
            Conformément au Code de la consommation, le client consommateur dispose d'un délai de
            <strong className="text-slate-100"> 14 jours</strong> à compter de la souscription pour
            exercer son droit de rétractation, sans avoir à justifier de motif. Ce délai écoulé,
            le droit de rétractation n'existe plus.
          </p>
          <p>
            Si le client demande expressément que l'accompagnement (accès à l'application Boussole,
            première séance) commence avant la fin de ce délai, il reste redevable, en cas de
            rétractation, d'un montant proportionnel au service déjà fourni jusqu'à la communication
            de sa décision. La rétractation s'exerce par simple email à yassineabou.contact@gmail.com.
          </p>
        </Section>

        <Section title="6 bis. Engagement du client et fin anticipée de l'accompagnement">
          <p>
            Le coaching repose sur l'implication du client : assiduité, participation aux échanges et
            mise en pratique des exercices. Si le coach constate que l'engagement du client ne permet
            pas un travail en adéquation avec les attentes et les résultats visés, il en informe le
            client et peut, après un échange, mettre fin à l'accompagnement par email.
          </p>
          <p>
            Dans ce cas, aucun prélèvement ultérieur n'est effectué et les prélèvements restants de la
            période d'engagement ne sont pas dus. En contrepartie, les sommes déjà réglées pour la
            période de 4 semaines entamée, correspondant à un accompagnement mis à disposition, ne donnent
            lieu à aucun remboursement.
          </p>
          <p>
            En cas de paiement annuel, si le coach met fin à l'accompagnement avant le terme des
            52 semaines, la part du prix correspondant aux périodes de 4 semaines non entamées est
            remboursée au client.
          </p>
        </Section>

        <Section title="7. Nature du service">
          <p>
            L'accompagnement proposé relève de la préparation mentale, de la pédagogie et du
            coaching sportif. Aucun résultat n'est garanti : il dépend de l'implication du client. Il ne se substitue en rien aux parcours de santé : en cas de
            difficultés dépassant ce cadre, l'apprenant et sa famille seront orientés vers
            les professionnels compétents.
          </p>
        </Section>

        <Section title="8. Données personnelles">
          <p>
            Les informations recueillies (formulaires, souscriptions) servent exclusivement à la gestion
            de l'accompagnement et ne sont jamais cédées à des tiers. Conformément au RGPD, vous disposez
            d'un droit d'accès, de rectification et de suppression en écrivant à
            yassineabou.contact@gmail.com.
          </p>
        </Section>

        <Section title="9. Litiges">
          <p>
            Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable
            sera recherchée en priorité ; à défaut, vous pouvez saisir le médiateur de la consommation
            compétent ou les tribunaux français.
          </p>
        </Section>

        <a
          href="/#tarifs"
          data-testid="cgv-back-link"
          className="mt-12 inline-flex items-center justify-center rounded-full bg-ember hover:bg-emberdark px-7 py-3.5 text-xs font-bold uppercase tracking-wide transition-colors duration-200"
        >
          Retour aux formules
        </a>
      </div>
    </div>
  );
}
